import styled from "styled-components"
import {H3} from "@irati/ui/src/Headings"

const Header = styled(H3)`
  padding: 7px 0;
`

export default Header
